import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createAction } from 'redux-act';

/**
 *
 * @param {string} prefix - the prefix applied to each actions
 * @param {object.<function?>} reducers
 * @returns {object.<BaseActionCreator>}
 */
export function createActions(prefix, reducers) {
  return Object.keys(reducers).reduce(function (acc, key) {
    var current = reducers[key];
    var name = "".concat(prefix, ": ").concat(key);
    var reducer = typeof current === 'function' ? current : function (arg) {
      return arg;
    };
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, createAction(name, reducer)));
  }, {});
}